// extracted by mini-css-extract-plugin
export default {"radioBox":"radio_radioBox__43jPq"};